// Set heading height in serviceCareer block
const body = document.querySelector('body');

window.addEventListener("load", () => {
    if (body.offsetWidth > 1200) {
        calcTitleHeight(3);
    } else if (body.offsetWidth <= 1200 && body.offsetWidth >= 768) {
        calcTitleHeight(2);
    } else if (body.offsetWidth < 768) {
        calcTitleHeight(1);
    }
}, true);

const calcTitleHeight = (colNumber) => {
    const bottomPageRedirectorSection = document.querySelectorAll('.block-bottomPageRedirector');

    bottomPageRedirectorSection.forEach(section => {
        const tiles = section.querySelectorAll('.card-title');
        let threeElemArrays = createThreeElemArrays(colNumber, tiles);

        threeElemArrays.forEach(row => {
            const heights = row.map(tile => tile.offsetHeight);
            const maxHeights = Math.max(...heights);
            row.map(item => item.style.minHeight = `${maxHeights}px`);
        });
    });
}

const createThreeElemArrays = (colNumber, tiles) => {
    let threeElemArrays = [];
    for (let idx = 0; idx < [...tiles].length; idx += colNumber) {
        threeElemArrays.push([...tiles].slice(idx, idx + colNumber));
    }

    return threeElemArrays;
}